<template>
  <div class="slider-container">
    <div
      class="slider h-full absolute top-0 left-0 w-[80%] mx-[10%]"
      @mousemove="handleMouseMove"
      @click="handleClick"
      @wheel="handleScroll"
      @touchstart="startTouch"
      @touchmove="moveTouch"
    >
      <div
        style=""
        class="slide-indicator fixed top-2 right-2 flex items-center"
      >
        <p class="text-3xl">{{ currentSlide + 1 }}/{{ slides.length }}</p>
        <div
          ref="closeIcon"
          @mouseenter="hideCursorText"
          @mouseleave="showCursorText"
        >
          <router-link to="/">
            <Icon
              icon="iwwa:close"
              width="30px"
              weight="regular"
              class="cursorCreu"
            />
          </router-link>
        </div>
      </div>
      <div
        class="slides h-full"
        :style="{ transform: `translateY(-${currentSlide * 100}%)` }"
      >
        <div class="slide h-full" v-for="(slide, index) in slides" :key="index">
          <div
            v-if="slide.type === 'text'"
            class="text-slide text-lg md:text-xl max-w-[650px]"
          >
            {{ $t(slide.content) }}
          </div>
          <div v-else-if="slide.type === 'image'" class="image-slide">
            <img
              :src="slide.content"
              alt="Slide Image"
              class="w-auto max-h-[80vh] rounded-lg"
            />
          </div>
          <div v-else-if="slide.type === 'video'" class="video-slide">
            <video
              :src="slide.content"
              alt="Slide Video"
              class="w-auto max-h-[80vh] rounded-lg"
              ref="video"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="hidden md:block cursor-text"
      :style="{ top: cursorY + 'px', left: cursorX + 'px' }"
    >
      {{ cursorText }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentSlide: 0,
      touchStartY: 0,
      touchEndY: 0,
      isScrolling: false,
      cursorText: "",
      cursorX: 0,
      cursorY: 0,
      isOverCloseIcon: false,
      cursorVisible: true,
    };
  },
  created() {
    this.cursorText = this.$t("next");
  },
  methods: {
    hideCursorText() {
      this.isOverCloseIcon = true;
      this.cursorText = ""; // Oculta el texto
    },
    showCursorText() {
      this.isOverCloseIcon = false;
      this.handleMouseMove({ clientY: this.cursorY }); // Vuelve a calcular el texto
    },
    nextSlide() {
      if (!this.isScrolling) {
        if (this.currentSlide < this.slides.length - 1) {
          this.currentSlide++;
        } else {
          this.currentSlide = 0; // Vuelve a la primera diapositiva
        }
        this.preventScrollForAWhile();
      }
    },
    prevSlide() {
      if (!this.isScrolling) {
        if (this.currentSlide > 0) {
          this.currentSlide--;
        } else {
          this.currentSlide = this.slides.length - 1; // Vuelve a la última diapositiva
        }
        this.preventScrollForAWhile();
      }
    },
    handleScroll(event) {
      if (this.isScrolling) return;

      if (event.deltaY > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    },
    startTouch(event) {
      this.touchStartY = event.touches[0].clientY;
    },
    moveTouch(event) {
      if (this.isScrolling) return;
      this.touchEndY = event.touches[0].clientY;
      if (this.touchStartY - this.touchEndY > 50) {
        this.nextSlide();
      }
      if (this.touchStartY - this.touchEndY < -50) {
        this.prevSlide();
      }
    },
    handleMouseMove(event) {
      const halfHeight = window.innerHeight / 2;
      this.cursorX = event.clientX;
      this.cursorY = event.clientY;
      if (this.isOverCloseIcon) {
        this.cursorText = ""; // Si está sobre la cruz, oculta el texto
        return;
      }
      console.log(this.currentSlide);
      if (event.clientY < halfHeight) {
        this.cursorText = this.$t("prev");
      } else {
        if (this.currentSlide === this.slides.length - 1) {
          this.cursorText = this.$t("torna");
        } else {
          this.cursorText = this.$t("next");
        }
      }
    },
    handleClick(event) {
      const halfHeight = window.innerHeight / 2;
      if (event.clientY < halfHeight) {
        this.prevSlide();
      } else {
        this.nextSlide();
      }
    },
    preventScrollForAWhile() {
      this.isScrolling = true;
      setTimeout(() => {
        this.isScrolling = false;
      }, 1300); // 1 segundo de pausa entre cambios
    },
    closeClock() {},
  },
};
</script>

<style>
.slider-container {
  width: calc(100% - 100px);
  margin: 0 auto;
}
.slider {
  position: relative;
  overflow: hidden;
  cursor: none;
}

.cursor-text {
  content: attr(data-cursor-text);
  top: 50%;
  left: 50%;
  position: fixed;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: var(--text-color);
  pointer-events: none;
  z-index: 10;
}

.slides {
  display: flex;
  flex-direction: column;
  transition: transform 0.5s ease-in-out;
}

.slide {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.text-slide {
  text-align: center;
}

button {
  position: absolute;
  bottom: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
}

button:nth-of-type(1) {
  left: 10px;
}

button:nth-of-type(2) {
  right: 10px;
}

.slide-indicator {
  position: fixed;
  top: 16px; /* Ajusta según sea necesario */
  right: 16px; /* Ajusta según sea necesario */
  padding: 5px 10px;
  border-radius: 5px;
}

.cursorCreu {
  cursor: pointer !important;
  z-index: 999 !important;
}
</style>